// extracted by mini-css-extract-plugin
export default {"deleteModal":"ResultDeleteModal_deleteModal__8wbPH","title":"ResultDeleteModal_title__gI-th","modalBody":"ResultDeleteModal_modalBody__9dpDO"};